import vendedoresApi from "@/app/services/vendedores";

export default {
    namespaced: true,
    state: {
        vendedor: null,
        vendedores: []
    },

    getters: {
      vendedoresSelect(state) {
        return state.vendedores.map(vendedor => {
          return {
            text: vendedor.id + ' - ' + vendedor.nome,
            value: vendedor.id
          }
        })
      }
    },

    mutations: {
      listar(state, vendedores) {
        state.vendedores = vendedores;
      },

      abrir(state, vendedor) {
        state.vendedor = vendedor;
      },

      salvar(state, vendedor) {
        state.vendedores.push(vendedor);
      },

      atualizar(state, vendedor) {
        let index = state.vendedores.findIndex(vendedor_ => vendedor_.id == vendedor.id);
        if (index > -1) {
          state.vendedores.splice(index, 1, vendedor);
        }
      },

      excluir(state, id) {
        let index = state.vendedores.findIndex(vendedor => vendedor.id == id);
        if (index > -1) {
          state.vendedores.splice(index, 1);
        }
      },

      UNSET_VENDEDOR(state) {
        state.vendedor = null;
      }
    },

    actions: {
      async listar({commit}) {
        commit('LOADING_ON', null, {root: true});
        let vendedores = await vendedoresApi.listar();
        commit('listar', vendedores);
        commit('LOADING_OFF', null, {root: true});
      },

      async abrir({commit}, id) {
        commit('LOADING_ON', null, {root: true});
        let vendedor = await vendedoresApi.abrir(id);
        commit('abrir', vendedor);
        commit('LOADING_OFF', null, {root: true});
      },

      async salvar({commit, dispatch}, vendedor) {
        let novoVendedor = await vendedoresApi.salvar(vendedor);
        commit('salvar', novoVendedor);
        dispatch('listas/vendedores', null, { root: true });
      },

      async atualizar({commit}, vendedor) {
        await vendedoresApi.atualizar(vendedor);
        commit('atualizar', vendedor);
      },

      async excluir({commit}, id) {
        await vendedoresApi.excluir(id);
        commit('excluir', id);
      }
    }
}
